export default {
  fetched: false,
  list: {},
  // shapes: {},
  stores: {},
  flyerGibs: {},
  flyerGibsChildIdsMap: {},
  current: null,
  currentFlyerStores: [],
  // nearbyFlyers: [],
  flyersPageContentHeight: null,
};
